var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.5 19.5",
    style: {
      enableBackground: "new 0 0 19.5 19.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,9.6c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.8,0-1.1l6.8-6.8h-3c-0.4,0-0.8-0.3-0.8-0.8S13.5,0,13.9,0 h4.8c0,0,0,0,0,0l0,0C18.9,0,19,0,19,0.1c0.1,0,0.2,0.1,0.2,0.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0c0.1,0.1,0.1,0.1,0.1,0.2 c0,0.1,0,0.2,0.1,0.3l0,0c0,0,0,0,0,0v4.8c0,0.4-0.3,0.8-0.8,0.8S18,6,18,5.6v-3l-6.8,6.8C11,9.5,10.8,9.6,10.6,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,19.5c-4.4,0-6.7,0-8.2-1.5S0,14.2,0,9.7s0-6.7,1.5-8.2S5.3,0,9.8,0c0.4,0,0.8,0.3,0.8,0.8 s-0.3,0.8-0.8,0.8c-4,0-6.1,0-7.2,1.1S1.5,5.7,1.5,9.8s0,6.1,1.1,7.1S5.7,18,9.8,18s6.1,0,7.1-1.1S18,13.8,18,9.8 C18,9.3,18.3,9,18.8,9s0.8,0.3,0.8,0.8c0,4.4,0,6.7-1.5,8.2C16.4,19.5,14.2,19.5,9.8,19.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.723acfd7ff3dd5f449e6701367b7e2cd.svg";
export { ForwardRef as ReactComponent };